import React from "react"

export function highlightMatches(text: string, query: string): React.ReactNode {
  if (!query || !text) return text

  const regex = new RegExp(
    `(${query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`,
    "gi"
  )
  const parts = text.split(regex)

  return parts.map((part, index) =>
    regex.test(part) ? <mark key={index}>{part}</mark> : part
  )
}
